<template>
    <section>
        <el-tabs type="border-card" class="border-card">
            <el-tab-pane label="表格">
                <Diagram></Diagram>
            </el-tab-pane>
            <el-tab-pane label="版本">
                <Version></Version>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>
<script>
    import Diagram from "./Diagram.vue"
    import Version from "./Version.vue"
    export default {
        components: {
            Diagram,
            Version
        },
        data() {
            return {}
        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/data/Data.vue